var React = require('react');

function Terminal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.88889 5H10H17.1111M13.5556 14H10.8889M6.44444 8L9.22222 11L6.44444 14M2 14.8002V5.20019C2 4.08009 2 3.51962 2.19377 3.0918C2.36421 2.71547 2.63598 2.40973 2.97049 2.21799C3.35077 2 3.84897 2 4.84462 2H15.1557C16.1514 2 16.6485 2 17.0288 2.21799C17.3633 2.40973 17.636 2.71547 17.8064 3.0918C18 3.5192 18 4.07899 18 5.19691V14.8031C18 15.921 18 16.48 17.8064 16.9074C17.636 17.2837 17.3633 17.5905 17.0288 17.7822C16.6489 18 16.152 18 15.1583 18L4.84173 18C3.848 18 3.35041 18 2.97049 17.7822C2.63598 17.5905 2.36421 17.2837 2.19377 16.9074C2 16.4796 2 15.9203 2 14.8002Z","stroke":"#87ABBF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Terminal.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Terminal;

Terminal.default = Terminal;
